import "./toolbar.scss";

import PropTypes from "prop-types";
import React from "react";

import CheckboxStates from "../../constants/checkboxStates";
import Icon from "../interface/Icon";

const iconForState = s => (s === CheckboxStates.CHECKED ? "tick" : s === CheckboxStates.MIXED ? "minus" : "blank");

const ToolbarPopoverListItem = props => (
  <div
    className={`toolbarPopoverListItem${
      props.showSelectedBackground && props.state === CheckboxStates.CHECKED ? ` selected` : ``
    }${!props.label ? " iconOnly" : ""}${props.showDescription ? " showDescription" : ""}`}
    onClick={e => {
      props.onClick(e, props.id);
    }}
  >
    {props.showSelectedIcon ? (
      <Icon icon={iconForState(props.state)} className="dropdownTick" color="iconMono" />
    ) : null}
    {props.showIcon ? (
      <Icon
        icon={props.icon ? props.icon : "blank"}
        className={props.iconClass}
        color={props.color ? props.color : "iconMono"}
      />
    ) : null}
    {props.label ? (
      <span>
        {props.label}
        {props.showDescription ? <div className={`toolbarPopoverListItemDescription`}>{props.description}</div> : null}
      </span>
    ) : null}
    {props.showShortcuts ? <span className="shortcut">{props.shortcut}</span> : null}
  </div>
);

ToolbarPopoverListItem.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconClass: PropTypes.string,
  color: PropTypes.string,
  showSelectedIcon: PropTypes.bool,
  showSelectedBackground: PropTypes.bool,
  showShortcuts: PropTypes.bool,
  showIcon: PropTypes.bool,
  shortcut: PropTypes.string,
  state: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  showDescription: PropTypes.bool,
  description: PropTypes.string
};

export default ToolbarPopoverListItem;
